export default __webpack_public_path__ + "c50af29e4831f85c44e0aa24f9c38370.svg";